<template>
  <div class="site-header-root">
      <!-- :class="{ 'home-site-header--home': isHomeRoute }" -->
    <header
      class="home-site-header home-site-header--home"
    
    >
      <div class="home-site-header__inner">
        <a
          class="home-site-header__brand"
          href="/"
          aria-label="返回首页"
          @click.prevent="navigateTo('/')"
        >
          <img
            class="home-site-header__logo home-site-header__logo--light"
            :src="lightLogoComboSrc"
            alt="INSIGMA 网新恩普 · 红云智汇"
          />
          <img
            class="home-site-header__logo home-site-header__logo--dark"
            :src="darkLogoComboSrc"
            alt="INSIGMA 网新恩普 · 红云智汇"
          />
        </a>
        <nav class="home-site-header__nav" aria-label="主导航">
          <a
            v-for="item in navItems"
            :key="item.to"
            class="home-site-header__link"
            :class="[
              { 'home-site-header__link--home': item.exact },
              navLinkClasses(item),
            ]"
            :href="item.to"
            @click.prevent="navigateTo(item)"
          >
            {{ item.label }}
          </a>
        </nav>
      </div>
    </header>

    <transition name="dl-modal-fade">
      <div
        v-if="forumModalOpen"
        class="dl-modal"
        role="dialog"
        aria-modal="true"
        tabindex="-1"
        aria-labelledby="forum-modal-title"
        @click.self="closeForumModal"
        @keyup.esc="closeForumModal"
      >
        <div class="dl-modal__panel" @click.stop>
          <button
            type="button"
            class="dl-modal__close"
            aria-label="关闭"
            @click="closeForumModal"
          >
            ×
          </button>
          <h3 id="forum-modal-title" class="dl-modal__title forum-modal__title">
            <i class="el-icon-info forum-modal__title-icon" aria-hidden="true"></i>
            站点跳转提醒
          </h3>
          <div class="forum-modal__body">
            <p>你正在跳转至公司内部论坛，访问须知如下：</p>
            <ol class="forum-modal__list">
              <li>
                <span class="forum-modal__item-label">访问前置要求：</span>
                <strong class="forum-modal__em">
                  必须连接公司VPN，未连通VPN无法打开论坛。
                </strong>
              </li>
              <li>
                <span class="forum-modal__item-label">账号登录规则：</span>
                若此前通过公司OA单点登录过论坛，可使用固定账号密码登录：
                <p class="forum-modal__cred">
                  <strong class="forum-modal__em">账号：你的中文姓名</strong>
                </p>
                <p class="forum-modal__cred">
                  <strong class="forum-modal__em"
                    >密码：你在公司oa论坛保存的手机号码@123456Bbs</strong
                  >
                </p>
                <p class="forum-modal__example">
                  例：姓名为张三，手机号码是13012344321，默认用户名密码为：
                  <strong class="forum-modal__em"
                    >张三/13012344321@123456Bbs</strong
                  >
                </p>
                <p class="forum-modal__note">
                  从未单点登录过论坛的人员，请打开论坛页面自行注册账号。
                </p>
              </li>
            </ol>
          </div>
          <div class="dl-form__actions">
            <button
              type="button"
              class="dl-btn dl-btn--ghost"
              @click="closeForumModal"
            >
              取消
            </button>
            <button
              type="button"
              class="dl-btn dl-btn--primary"
              @click="confirmForumModal"
            >
              前往论坛
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { publicAssetUrl } from "@/utils/publicAsset";

const NAV_ITEMS = [
  { label: "首页", to: "/", exact: true },
  { label: "解决方案", to: "/solutions" },
  { label: "产品中心", to: "/products" },
  { label: "资源下载", to: "/download" },
  { label: "新闻动态", to: "/news" },
  { label: "关于红云", to: "/about" },
  { label: "员工论坛", to: "http://192.168.183.101:81/", external: true },
];

export default {
  name: "SiteHeader",
  data() {
    return {
      navItems: NAV_ITEMS,
      forumModalOpen: false,
      pendingForumUrl: "",
    };
  },
  computed: {
    isHomeRoute() {
      return this.$route.path === "/";
    },
    darkLogoComboSrc() {
      return this.publicAsset("home-slices/header-logos-dark.png");
    },
    lightLogoComboSrc() {
      return this.publicAsset("home-slices/header-logos-light.png");
    },
  },
  watch: {
    forumModalOpen(val) {
      document.body.style.overflow = val ? "hidden" : "";
    },
  },
  beforeDestroy() {
    document.body.style.overflow = "";
  },
  methods: {
    publicAsset(path) {
      return publicAssetUrl(path);
    },
    navigateTo(item) {
      const target = typeof item === "string" ? { to: item } : item;
      if (target.external) {
        this.openForumModal(target.to);
        return;
      }
      if (this.$route.path !== target.to) {
        this.$router.push(target.to);
        document.body.scrollTop = 0;
      }
    },
    openForumModal(url) {
      this.pendingForumUrl = url;
      this.forumModalOpen = true;
    },
    closeForumModal() {
      this.forumModalOpen = false;
      this.pendingForumUrl = "";
    },
    confirmForumModal() {
      const url = this.pendingForumUrl;
      this.closeForumModal();
      if (url) {
        window.open(url, "_blank", "noopener,noreferrer");
      }
    },
    isNavActive(to, exact = false) {
      if (typeof to === "string" && /^https?:\/\//.test(to)) {
        return false;
      }
      const { path } = this.$route;
      if (exact) {
        return path === to;
      }
      return path === to || path.startsWith(`${to}/`);
    },
    navLinkClasses({ to, exact = false }) {
      const active = this.isNavActive(to, exact);
      return {
        "router-link-active": active,
        "router-link-exact-active": this.$route.path === to,
      };
    },
  },
};
</script>

<style lang="less">
@import "@/assets/styles/variables.less";

@header-text: #1a1a1a;
@nav-underline-h: 4px;
@nav-underline-r: 2px;

.tab-underline-base() {
  content: "";
  position: absolute;
  bottom: 0;
  height: @nav-underline-h;
  border-radius: @nav-underline-r;
  background: @red;
}

.home-site-header {
  position: fixed;
  inset: 0 0 auto 0;
  z-index: 1200;
  height: 88px;
  background: transparent;
  box-shadow: none;
  -webkit-backdrop-filter: none;
  backdrop-filter: none;
  transition: background-color 0.22s ease, box-shadow 0.22s ease,
    -webkit-backdrop-filter 0.22s ease, backdrop-filter 0.22s ease;

  .home-site-header__inner {
    box-sizing: border-box;
    height: 100%;
    margin: 0 0 0 80px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    min-width: 0;
  }

  .home-site-header__brand {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    text-decoration: none;
  }

  .home-site-header__logo {
    display: block;
    height: 44px;
    width: auto;
    max-width: min(320px, 28vw);
    object-fit: contain;
    object-position: left center;

    &.home-site-header__logo--dark {
      display: none;
    }
  }

  .home-site-header__nav {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: nowrap;
    flex: 1 1 auto;
    min-width: 0;
    gap: 0;

    .home-site-header__link {
      position: relative;
      flex: 0 0 auto;
      padding: 8px 0;
      font-size: 26px;
      width: 116px;
      margin: 0 20px;
      line-height: 1.3;
      font-weight: 500;
      color: @header-text;
      text-decoration: none;
      white-space: nowrap;
      transition: color 0.2s ease;
      text-align: center;
      &:hover,
      &.router-link-active {
        color: @red;
      }

      &:focus-visible {
        outline: 2px solid fade(@red, 45%);
        outline-offset: 4px;
      }

      &.home-site-header__link--home.router-link-exact-active::after {
        .tab-underline-base();
        left: 50%;
        transform: translateX(-50%);
        width: 48px;
      }

      &:not(.home-site-header__link--home).router-link-active::after {
        .tab-underline-base();
        left: 0;
        right: 0;
      }
    }
  }
}

/* 低分辨率：缩小字号/间距，保证导航单行不换行 */
@media (max-width: 1600px) {
  .home-site-header {
    .home-site-header__inner {
      margin-left: 48px;
      padding: 0 16px;
      gap: 16px;
    }

    .home-site-header__nav .home-site-header__link {
      font-size: 22px;
      width: 100px;
      margin: 0 12px;
    }
  }
}

@media (max-width: 1360px) {
  .home-site-header {
    height: 76px;

    .home-site-header__inner {
      margin-left: 28px;
      padding: 0 12px;
      gap: 12px;
    }

    .home-site-header__logo {
      height: 36px;
      max-width: min(240px, 22vw);
    }

    .home-site-header__nav .home-site-header__link {
      font-size: 18px;
      width: 86px;
      margin: 0 6px;
      padding: 6px 0;

      &.home-site-header__link--home.router-link-exact-active::after {
        width: 36px;
        height: 3px;
      }

      &:not(.home-site-header__link--home).router-link-active::after {
        height: 3px;
      }
    }
  }
}

@media (max-width: 1100px) {
  .home-site-header {
    height: 68px;

    .home-site-header__inner {
      margin-left: 16px;
      padding: 0 8px;
      gap: 8px;
    }

    .home-site-header__logo {
      height: 30px;
      max-width: min(180px, 18vw);
    }

    .home-site-header__nav .home-site-header__link {
      font-size: 15px;
      width: auto;
      min-width: 0;
      margin: 0 4px;
      padding: 4px 2px;

      &.home-site-header__link--home.router-link-exact-active::after {
        width: 28px;
      }
    }
  }
}

/* 首页且未滚动：10% 白 + 毛玻璃 */
body:not(.header-scrolled) .home-site-header.home-site-header--home {
  background: rgba(255, 255, 255, 0.1);
  -webkit-backdrop-filter: blur(12px);
  backdrop-filter: blur(12px);
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.14);
}

/* 首页已滚动：不透明白底 */
body.header-scrolled {
  .home-site-header {
    background: #fff;
    -webkit-backdrop-filter: none;
    backdrop-filter: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
}

/* 非首页：不透明白底、无模糊 + 浅色 Logo */
.home-site-header:not(.home-site-header--home) {
  background: #fff;
  -webkit-backdrop-filter: none;
  backdrop-filter: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .home-site-header__logo--dark {
    display: none !important;
  }

  .home-site-header__logo--light {
    display: block !important;
  }
}

/* 浅色 Logo：首页浅色轮播 / 深色轮播且已滚动 */
.home-hero-light-header,
.header-scrolled.home-hero-dark-header {
  .home-site-header.home-site-header--home {
    .home-site-header__logo--dark {
      display: none !important;
    }

    .home-site-header__logo--light {
      display: block !important;
    }
  }
}

/* 深色首屏且未滚动（顶栏毛玻璃由 body:not(.header-scrolled) .home-site-header--home 统一控制） */
.home-hero-dark-header:not(.header-scrolled) {
  .home-site-header.home-site-header--home {
    .home-site-header__logo--light {
      display: none !important;
    }

    .home-site-header__logo--dark {
      display: block !important;
    }

    .home-site-header__nav .home-site-header__link {
      color: rgba(244, 248, 255, 0.92);
      text-shadow: 0 1px 8px rgba(0, 0, 0, 0.35);

      &:hover,
      &.router-link-active {
        color: #fff;
        text-shadow: 0 1px 10px rgba(0, 0, 0, 0.45);
      }

      &.home-site-header__link--home.router-link-exact-active::after,
      &:not(.home-site-header__link--home).router-link-active::after {
        background: rgba(255, 255, 255, 0.92);
      }
    }
  }
}

/* 员工论坛弹窗：与资源下载「下载登记」一致 */
.dl-modal {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  box-sizing: border-box;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(2px);
}

.dl-modal__panel {
  position: relative;
  width: min(520px, 100%);
  max-height: min(90vh, 720px);
  overflow: auto;
  padding: 28px 28px 24px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 24px 48px rgba(15, 23, 42, 0.18);
  border: 1px solid #e2e8f0;
}

.dl-modal__close {
  position: absolute;
  top: 12px;
  right: 14px;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #64748b;
  font-size: 26px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.dl-modal__close:hover {
  background: #f1f5f9;
  color: #0f172a;
}

.dl-modal__title {
  margin: 0 0 8px;
  padding-right: 36px;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: #1e293b;
}

.forum-modal__title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.forum-modal__title-icon {
  flex-shrink: 0;
  font-size: 22px;
  color: #409eff;
  letter-spacing: 0;
}

.dl-modal__subtitle {
  margin: 0 0 20px;
  font-size: 14px;
  line-height: 1.55;
  color: #64748b;
  letter-spacing: 0.04em;
}

.forum-modal__body {
  margin: 0 0 8px;
  font-size: 15px;
  line-height: 1.75;
  color: #303133;
  letter-spacing: 0.02em;

  > p {
    margin: 0 0 14px;
  }
}

.forum-modal__list {
  margin: 0;
  padding-left: 1.35em;
  list-style: decimal;

  > li {
    margin: 0 0 14px;
    padding-left: 0.15em;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.forum-modal__item-label {
  font-weight: 600;
  color: #303133;
}

.forum-modal__em {
  color: #f56c6c;
  font-weight: 700;
}

.forum-modal__cred {
  margin: 6px 0 0 !important;
  padding-left: 0.5em;
}

.forum-modal__example {
  margin: 8px 0 0 !important;
  color: #303133;
}

.forum-modal__note {
  margin: 8px 0 0 !important;
  color: #303133;
}

.dl-form__actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;
  padding-top: 4px;
}

.dl-btn {
  padding: 10px 22px;
  border-radius: 8px;
  font-size: 15px;
  letter-spacing: 0.06em;
  cursor: pointer;
  border: 1px solid transparent;
  transition: background 0.2s, border-color 0.2s, opacity 0.2s;
}

.dl-btn--ghost {
  background: #fff;
  border-color: #cbd5e1;
  color: #475569;
}

.dl-btn--ghost:hover {
  background: #f8fafc;
}

.dl-btn--primary {
  background: linear-gradient(134deg, #0a6ebd 0%, #2563eb 100%);
  color: #fff;
  box-shadow: 0 4px 14px rgba(10, 110, 189, 0.38);
}

.dl-btn--primary:hover {
  filter: brightness(1.05);
}

.dl-modal-fade-enter-active,
.dl-modal-fade-leave-active {
  transition: opacity 0.22s ease;
}

.dl-modal-fade-enter,
.dl-modal-fade-leave-to {
  opacity: 0;
}
</style>
